<div class="dcf-hero dcf-hero-default">
  <!-- TemplateEndEditable -->
  <div class="dcf-hero-group-1">
    <div class="dcf-breadcrumbs-wrapper">
      <nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
        <!-- TemplateBeginEditable name="breadcrumbs" -->
        <ol>
          <li><a href="https://www.unl.edu/">Nebraska</a></li>
          <li><a href="/">TCAN / VITA Lincoln</a></li>
          <li><a href="/management">Management</a></li>
          <li><span aria-current="page">Site Management</span></li>
        </ol>
        <!-- TemplateEndEditable -->
      </nav>
    </div>
    <header class="dcf-page-title" id="dcf-page-title">
      <!-- TemplateBeginEditable name="pagetitle" -->
      <h1>Site Management</h1>
      <!-- TemplateEndEditable -->
    </header>
    <!-- TemplateBeginEditable name="herogroup1" -->
    <!-- TemplateEndEditable -->
  </div>
  <!-- TemplateBeginEditable name="herogroup2" -->
  <div class="dcf-hero-group-2">
  </div>
  <!-- TemplateEndEditable -->
</div>

<div class="dcf-wrapper dcf-pb-8">
  <div class="dcf-grid">
    <!-- Site select list -->
    <div class="dcf-col-25%-start dcf-pr-10">
      <ul class="dcf-list-bare">
        @for (site of sites; track site) {
          <li class="site-list-element"
            (click)="selectSite(site)">
            <a>{{site.title}}</a>
          </li>
        }
      </ul>

      <!-- Shown when there are no sites -->
      @if (sites.length === 0) {
        <div class="centered-text">
          <p>There are no sites.</p>
        </div>
      }
    </div>





    <!-- Site Information Area -->
    <div class="dcf-col-75%-end">
      <!-- Shown if a site is selected and loaded from backend -->
      @if (selectedSite != null && siteInformation != null) {
        <div>
          <h3 class="clear-top">{{siteInformation.title}}</h3>
          <div class="dcf-mb-4">
            <div><b>Address:</b> {{siteInformation.address}}</div>
            <div><b>Phone Number:</b> {{siteInformation.phoneNumber}}</div>
          </div>
          <!-- Appointment Times Section -->
          <h4>Appointment Times:</h4>
          <div>
            <p>Appointment times represents a time slot in which a client can sign up for an appointment and the rules surrounding the number of appointments during that time slot.
              <!-- Add appointment time section -->
              <div class="dcf-mb-5">
                @if (addAppointmentTimeButtonClicked === true) {
                  <div>
                    <h5>Add an Appointment Time</h5>
                    <div [hidden]="error === null" class="alert alert-warning" role="alert">
                      {{ error }}
                    </div>
                    <form class="cmxform dcf-form"
                      id="addAppointmentTimeForm"
                      name="form"
                      (submit)="addAppointmentTimeSaveButtonHandler()"
                      autocomplete="off"
                      novalidate>
                      <section class="dcf-form-group">
                        <label class="dcf-label form-required">Date</label>
                        <mat-form-field class="example-full-width">
                          <mat-label class="form-label form-required">Date</mat-label>
                          <input matInput [matDatepickerFilter]="dateFilter" name="date-Picker" [matDatepicker]="picker" [(ngModel)]="selectedDate" (ngModelChange)="dateChanged($event)" >
                          <mat-hint>MM/DD/YYYY</mat-hint>
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <div ng-show="form.$submitted || form.dateInput.$touched">
                          <label class="error" ng-show="form.dateInput.$error.required">This field is required.</label>
                        </div>
                      </section>
                      <section class="dcf-form-group">
                        <label class="dcf-label form-required" for="addAppointmentTimeScheduledTimeSelect">Scheduled Time</label>
                        <select id="addAppointmentTimeScheduledTimeSelect"
                          name="scheduledTimeSelect"
                          class="dcf-input-select dcf-mb-0"
                          [(ngModel)]="addAppointmentTimeInformation.scheduledTimeString"
                          ng-options="time for time in addAppointmentTimeScheduledTimeOptions"
                          required>
                          <option value="" style="display:none;">-- Select a Scheduled Time --</option>
                          @for (time of addAppointmentTimeScheduledTimeOptions; track time) {
                            <option
                              [ngValue]="time.timeString">
                              {{ time.timeString }}
                            </option>
                          }
                        </select>
                        <div ng-show="form.$submitted || form.scheduledTimeSelect.$touched">
                          <label class="error" ng-show="form.scheduledTimeSelect.$error.required">This field is required.</label>
                        </div>
                      </section>
                      <section class="dcf-form-group">
                        <label class="dcf-label form-required" for="addAppointmentTimeAppointmentTypeSelect">Appointment Type</label>
                        <select id="addAppointmentTimeAppointmentTypeSelect"
                          name="appointmentTypeSelect"
                          class="dcf-input-select"
                          [(ngModel)]="addAppointmentTimeInformation.appointmentType"
                          required>
                          <option value="" style="display:none;">-- Select An Appointment Type --</option>
                          @for (option of appointmentTypes; track option) {
                            <option [value]="option.appointmentTypeId">{{option.name}}</option>
                          }
                        </select>
                        <div ng-show="form.$submitted || form.appointmentTypeSelect.$touched">
                          <label class="error" ng-show="form.appointmentTypeSelect.$error.required">This field is required.</label>
                        </div>
                      </section>
                      <section class="dcf-form-group">
                        <label class="dcf-label form-required" for="addAppointmentTimeNumberOfAppointments">Number of Appointments</label>
                        <input id="addAppointmentTimeNumberOfAppointments"
                          type="number"
                          class="dcf-input-text"
                          name="numberOfAppointments"
                          [(ngModel)]="addAppointmentTimeInformation.numberOfAppointments"
                          min="0"
                          required />
                        <div ng-show="form.$submitted || form.numberOfAppointments.$touched">
                          <label class="error" ng-show="form.numberOfAppointments.$error.required">This field is required.</label>
                        </div>
                      </section>
                      <section class="dcf-form-group">
                        <label class="dcf-label form-required" for="is_hidden">Is Hidden</label>
                        <select [(ngModel)]="addAppointmentTimeInformation.is_hidden" id="is_hidden" name="is_hidden">
                          <option [value]="0">Public can view this appt time</option>
                          <option [value]="1">Only staff can see this appt time</option>
                        </select>
                        <div ng-show="form.$submitted || form.numberOfAppointments.$touched">
                          <label class="error" ng-show="form.numberOfAppointments.$error.required">This field is required.</label>
                        </div>
                      </section>
                      <div class="dcf-mt-3">
                        <button type="button"
                          class="dcf-btn dcf-btn-secondary"
                        (click)="addAppointmentTimeCancelButtonHandler()">Cancel</button>
                        <input type="submit"
                          value="Save"
                          class="submit dcf-btn dcf-btn-primary"
                          [disabled]="savingAppointmentTime === true">
                      </div>
                    </form>
                  </div>
                }
                <!-- Button for adding an appointment time -->
                @if (addAppointmentTimeButtonClicked === false) {
                  <button class="dcf-btn dcf-btn-primary dcf-mt-3"
                    (click)="addAppointmentTimeButtonHandler()"
                  >Add Appointment Time</button>
                }
              </div>
              <!-- Displayed when there are no appointment times -->
              @if (siteDescriptiveTimes.length <= 0) {
                <div>
                  <p>There are no appointment times yet</p>
                </div>
              }
              <!-- Displayed when there are appointment times -->
              @if (siteDescriptiveTimes.length > 0) {
                <div>
                  @for (appointmentTime of siteDescriptiveTimes; track appointmentTime) {
                    <div class="dcf-mb-5">
                      <h5>{{appointmentTime}}</h5>
                      <table class="dcf-table dcf-table-striped dcf-w-100%">
                        <thead>
                          <tr>
                            <th id="appointmentTimeScheduledTimeHeader">Scheduled Time</th>
                            <th id="appointmentTimeAppointmentTypeHeader">Type</th>
                            <th id="appointmentTimeAppointmentTypeHeader">Is Hidden</th>
                            <th id="appointmentTimeNumberOfAppointmentsHeader">Appointments (scheduled/allowed)</th>
                            <th id="appointmentTimeEditHeader">Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (appointmentTimeOnDate of appointmentTimes[appointmentTime]; track appointmentTimeOnDate) {
                            <tr>
                              <th id="appointmentTime{{appointmentTimeOnDate.appointmentTimeId}}">{{appointmentTimeOnDate.scheduledTimeString}}</th>
                              <td headers="appointmentTimeAppointmentTypeHeader appointmentTime{{appointmentTimeOnDate.appointmentTimeId}}">{{appointmentTimeOnDate.appointmentType}}</td>
                              <td headers="appointmentTimeAppointmentTypeHeader appointmentTime{{appointmentTimeOnDate.appointmentTimeId}}">{{appointmentTimeOnDate.is_hidden}}</td>
                              <td headers="appointmentTimeNumberOfAppointmentsHeader appointmentTime{{appointmentTimeOnDate.appointmentTimeId}}">
                                {{appointmentTimeOnDate.numberOfAppointmentsAlreadyScheduled}} /
                                <span [hidden]="appointmentTimeOnDate.editing">
                                  {{appointmentTimeOnDate.numberOfAppointments}}
                                </span>
                                <span [hidden]="!appointmentTimeOnDate.editing">
                                  <input id="addAppointmentTimeNumberOfAppointments"
                                    type="number"
                                    class="dcf-input-text dcf-d-inline"
                                    [(ngModel)]="appointmentTimeOnDate.numberOfAppointments"
                                    min="0"
                                    required />
                                </span>
                              </td>
                              <td headers="appointmentTimeEditHeader appointmentTime{{appointmentTimeOnDate.appointmentTimeId}}">
                                <div [hidden]="appointmentTimeOnDate.editing">
                                  <button type="button"
                                    class="dcf-btn dcf-btn-primary"
                                    (click)="editAppointmentTimesEditButtonHandler(appointmentTimeOnDate)">
                                    Edit
                                  </button>
                                </div>
                                <div [hidden]="!appointmentTimeOnDate.editing">
                                  <button type="button"
                                    class="dcf-btn dcf-btn-secondary"
                                    (click)="appointmentTimeOnDate.editing = false">
                                    Cancel
                                  </button>
                                  <button type="button"
                                    class="dcf-btn dcf-btn-primary"
                                    (click)="editAppointmentTimeSaveButtonHandler(appointmentTimeOnDate)">
                                    Save
                                  </button>
                                </div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- Shown if no site is selected -->
        @if (selectedSite == null) {
          <div class="centered-text">
            <p>Select a site on the left.</p>
          </div>
        }
      </div>
    </div>
  </div>